/*
 Initial state and properties
 */
 export const initialState = {
    defaultDataCut: null
}
/*
 Action types
 */
export const SET_DEFAULT_DATA_CUT = 'SET_DEFAULT_DATA_CUT'
/*
 Arrow function for change state
 */
export const setDefaultDataCut = (payload) => ({
    type: SET_DEFAULT_DATA_CUT,
    payload,
});
/*
 Reducer to describe how the state changed
 */
export default function Reducer(state = initialState, { type, payload }) {
    switch (type) {
        case SET_DEFAULT_DATA_CUT:
            return {
                ...state,
                defaultDataCut: payload,
            }
        default:
            return state
    }
}
